import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTeletype } from '@fortawesome/free-solid-svg-icons';
import { useState , useEffect, useContext} from 'react';
import './Home.css'
import OperationComponent from './components/OperationComponent';
import CircularProgress from '@mui/joy/CircularProgress';
import ProtectedRoute from './ProtectedRoute';
import { useOutletContext , useNavigate} from 'react-router-dom';
import { Product } from './models/models';
function Home() {
    const { balance , limit , first , offer , location_required } = useOutletContext();
    const limitReached = limit && !limit.isNaN && !balance.isNaN && Number(limit) !== 0 && Number(limit) - Number(balance) <= 0 ;
    const [operationNotComplet, setOperationNotComplet] = useState(false);
    const [locationEnabled, setLocationEnabled] = useState(false);
    let userGMPLink = null
    function askForLocationPermission() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLocationEnabled(true);
            userGMPLink = `https://www.google.com/maps/search/?api=1&query=${position.coords.latitude},${position.coords.longitude}`;
          },
          (error) => {
            setLocationEnabled(false);
          }
        );
      } 
    }

    useEffect(() => {
      if(first) {
      askForLocationPermission();
      fetchOperations();
      }
    },[]);
    const navigate = useNavigate();

     const selectedProduct = new Product(
        360,
        '*6',
        30,
        30,
        'illimité réseaux sociaux'
    );
    let rest = 0
    if (limit && !isNaN(limit) && Number(limit) !== 0) {
        rest = Number(limit) - Number(balance);
    }
     const handlePurchase = (selectedProduct) => {
        let number;
        number = document.getElementById('number').value;
        if(number && number.toString().length === 10){
        } else {
            number = null
            setError('يجب إدخال رقم مكون من 10 أرقام');
        }
        if (!selectedProduct || !number) return;
        const productDetails = `
    ** المرجوا التـأكد قبل الدفع فلا يوجد تعويض على الخطأ **
    الاسم: ${selectedProduct.productName}
    السعر: ${selectedProduct.finalPrice} درهم
    الصلاحية: ${selectedProduct.validity} أيام

    سيتم شحن الرقم: ${number.replace("212","0")}

    هل تريد متابعة عملية الشراء؟
        `;
        
        // Show confirmation alert
        if(window.confirm(productDetails)) {
            // Navigate to payment page with product details
            navigate('/payment', { 
                state: { 
                    product: selectedProduct,
                    phoneNumber: "212" + number.slice(1)

                } 
            });
        }
    };
    const [error, setError] = useState(()=>'');
    const [loading, setLoading] = useState(() => false);
    const [operations, setOperations] = useState(() => []);
    const handleSubmit = (e) => {
        e.preventDefault();
        const data = new FormData(e.target);
        const postData = {
          number: data.get('number')
        };
        if(postData.number && postData.number.toString().length === 10){
            window.location.href = '/offers/' + postData.number;
        } else {
            setError('يجب إدخال رقم مكون من 10 أرقام');
        }
      }
      function fetchOperations(){
        const op = []
        setLoading(true)
        setOperations(op)
        axios.get('https://rechargemoi.ma/backend/api/operations', {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }).then((response) => {
          for (let i = 0; i < response.data.length; i++) {
              op.push({
                price: response.data[i].price,
                name: response.data[i].productName,
                client: response.data[i].client,
                time: new Date(response.data[i].time * 1000).toLocaleString('en-GB', { timeZone: 'Africa/Casablanca' }),
                success: response.data[i].success
              })
          }
          for (let i = 0; i < op.length; i++) {
            if(op[i].success != '1' && op[i].success != '0') {
              setOperationNotComplet(true);
              setTimeout(() => {
                fetchOperations();
              }, 5000);
              break;
            }
          }
          setOperations(op);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false)
        });
      }
      console.log('rendering home ... ', location_required);
      return (
            <div className="container">
              <form method='POST' onSubmit={handleSubmit} className="mt-5">
              <img src="logo.jpeg" alt="logo" id='logo' height={100} width={100} />
                <div className="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                    <FontAwesomeIcon icon={faTeletype} />
                    </span>
                  </div>
                  <input type="number" className="form-control" id="number" name="number" required  placeholder={limitReached ? 'لقد وصلت للحد الأقصى' : 'أدخل الرقم'} disabled={limitReached || (location_required && !locationEnabled)} />
                </div>
                <div class="d-grid gap-2">
                  <button type="submit" className="btn btn-primary" id='login' disabled={limitReached || (location_required && !locationEnabled)}>تأكيد</button>
                  <p id="error">{error}</p>
                </div>
              </form>
              {location_required && !locationEnabled && (
                <div className="alert alert-warning mt-3" role="alert">
                  هذا الحساب يتطلب تفعيل الموقع الجغرافي للمتابعة. <button className="btn btn-link" onClick={askForLocationPermission}>اضغط هنا لتفعيل الموقع</button>
                </div>
              )}
              {selectedProduct && offer && !(limit && !balance.isNaN && !limit.isNaN && limit != 0 && limit - balance < selectedProduct.finalPrice) && !(location_required && !locationEnabled) && (

                            <button
                                className="purchase-button"
                                onClick={() => handlePurchase(selectedProduct)}
                                disabled={(limit && !balance.isNaN && !limit.isNaN && limit != 0 && limit - balance < selectedProduct.finalPrice)}
                            >
                                {limitReached ? "الحد الأقصى للرصيد تم الوصول إليه" :  (limit && rest !== 0 && limit !== 0 && rest < selectedProduct.finalPrice) ? "لا يوجد رصيد كافي لاجراء العملية ، متبقي "+ rest +" ثمن العملية : " + selectedProduct.finalPrice  : "شراء عرض 30 درهم نجمة 6"}
                            </button>
                    )}
              <div className="container">
                {!loading ? operations.map((operation, index) => (
                  <OperationComponent key={index} price={operation.price} name={operation.name} client={operation.client} time={operation.time} success={operation.success} />
                )) : <CircularProgress variant="solid" size='sm' color='neutral'/>}
                {operations.length === 0 && !loading && (
                  <p className="text-center">لا توجد عمليات سابقة</p>
                )}
                {operations.length === 3 && !loading && (
                  <button className="btn btn-primary" id='login' onClick={
                    () => {
                      window.location.href = '/operations';
                    }
                  }>المزيد من العمليات</button>
                )}
    </div>
            </div>
    )
}

export default Home;